import React, { useEffect, useState } from 'react';
import { MonitorIcon } from 'lucide-react';
const MIN_WIDTH = 1100;
export function DesktopGate({
  children
}: {
  children: React.ReactNode;
}) {
  const [wide, setWide] = useState(typeof window === 'undefined' ? true : window.innerWidth >= MIN_WIDTH);
  useEffect(() => {
    const onResize = () => setWide(window.innerWidth >= MIN_WIDTH);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);
  if (wide) return <>{children}</>;
  return <main className="flex min-h-full w-full items-center justify-center bg-paper p-8" data-id="element-91" data-mp="3bnmj9fxo7b2a">
      <div className="max-w-md rounded-sm border border-rule bg-white p-8 text-center" data-id="element-92" data-mp="2wyqafgnshu0m">
        <MonitorIcon className="mx-auto h-6 w-6 text-muted" data-id="element-93" data-mp="31xjj8vs4swug" />
        <h1 className="mt-4 text-lg font-semibold text-ink" data-id="element-94" data-mp="3pofhaan6koa5">
          This assessment needs a wider screen
        </h1>
        <p className="mt-2 text-sm leading-relaxed text-slate-600" data-id="element-95" data-mp="3uf5jjf0b8b0m">
          The workspace places source documents, the ledger and the assistant side by side, so it
          runs on a desktop or laptop display at least 1100&nbsp;pixels wide. Please reopen it there
          — nothing has been started and no time has been used.
        </p>
      </div>
    </main>;
}